export const authEvents = {
    LOGIN: 'login',
    LOGOUT: 'logout',
    REGISTER: 'register',
    RESET_PASSWORD: 'reset-password',
    SET_NEW_PASSWORD: 'set-new-password',
    UPDATE_USER_DATA: 'update-user-data'
};
